export { default } from './source-detail';
